export enum Event {
  acceptButtonClicked = 'acceptButtonClicked',
  dismissClicked = 'dismissClicked',
  openedPanel = 'openedPanel',
  saveButtonClicked = 'saveButtonClicked',
}

export interface Logger {
  acceptButtonClicked: () => void
  openedPanel: () => void
  saveButtonClicked: (toggle: boolean) => void
  declineAllClicked: () => void
  dismissClicked: () => void
  cookieLinkClicked: () => void
  toggleClicked: (toggle: boolean) => void
  cookieLinkClickedModal: () => void
  closePanelClicked: () => void
  rendered: () => void
}

// BI catalog: https://bo.wix.com/bi-catalog-webapp/#/sources/5/events/814?artifactId=gdpr-statics
export interface LogObject {
  evid: number
  url: string
  toggle?: boolean
  policy?: 'cookie'
  action?:
    | 'accept'
    | 'settings'
    | 'dismiss'
    | 'read_policy'
    | 'render'
    | 'decline_all'
    | 'save'
}
